<h1>{{ title }}</h1>

<div class="container">
  <div class="game-scores">
    <sans-game-scores
      [user]="user"
      [rightOpponent]="rightOpponent"
      [leftOpponent]="leftOpponent"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
    ></sans-game-scores>
  </div>

  <div class="results">
    <div class="result">
      <div>
        {{ centerPlayerGameResult.username }}
      </div>

      <div>
        {{ centerPlayerGameResult.poolPoints }}
      </div>
    </div>

    <div class="result">
      <div>
        {{ rightPlayerGameResult.username }}
      </div>

      <div>
        {{ rightPlayerGameResult.poolPoints }}
      </div>
    </div>

    <div class="result">
      <div>
        {{ leftPlayerGameResult.username }}
      </div>

      <div>
        {{ leftPlayerGameResult.poolPoints }}
      </div>
    </div>
  </div>
</div>

<div class="home-button">
  <button
    mat-raised-button
    color="primary"
    (click)="onHomeClicked()"
    class="leave-game-button"
  >
    {{ homeButtonLabel }}
  </button>
</div>
